<template>
<v-app>
 <v-dialog
      v-model="dialog"
      width="980"
    >
    <v-card>
      <v-card-title
        class="headline w-100"
      >

          <v-spacer></v-spacer>
          <div
            class="float-right"><v-btn
            icon
            @click="dialog = false">
            <span class="fal fa-2x fa-times"></span>
          </v-btn>
          </div>
      </v-card-title>

      <v-card-text class="pb-5">
        <p class="h3 text-center"> {{ title }}</p>

        <iframe v-if="video" allowfullscreen :src="video" class="modal-iframe"></iframe>
        <img v-else :src="image" class="modal-iframe" />

        <div v-html="content"></div>

        <div class="modal-testimonial">
          <div class="row">
            <div class="col-24 col-md-8  text-center">
              <img :src="refimage" :alt="reftitle" />
            </div>

            <div class="col-24 col-md-15 offset-md-1">
              <p class="h4">{{ reftitle }}</p>
              <p>{{ reftext }}</p>
            </div>
          </div>
        </div>

        <p class="text-center">
          <button
            class="btn btn-primary"
            @click="dialog = false"
          >
            Fenster schließen
          </button>
        </p>
      </v-card-text>
    </v-card>
</v-dialog>
</v-app>
</template>

<script>
export default {
  name: "Modal",

  data() {
    return {
      dialog: false
    }
  },

  computed: {
    name() {
      return this.$root.name;
    },

    title() {
      return this.$root.title;
    },

    content() {
      return this.$root.content["content"];
    },

    video() {
      return this.$root.content["video"];
    },

    reftitle() {
      return this.$root.content["reftitle"];
    },

    reftext() {
      return this.$root.content["reftext"];
    },

    refimage() {
      return this.$root.content["refimage"];
    },

    image() {
      return this.$root.content["image"];
    }
  },

  mounted() {
    const openButton = document.querySelector("a[href='#" + this.name + "']");
    if (openButton) {
      openButton.addEventListener("click", (e) => {
        e.preventDefault();

        this.dialog = true;
      });
    }
  }
}
</script>
